import { NavigationGuardNext, RouteLocationNormalized } from 'vue-router'
import useInactivityTimer from '@/composables/inactivityTimeout.ts'
import { isAuthenticated, login, userRole } from '@/lib/AuthenticatorPlugin.ts'
import { ISessionStore } from '@/store/pinia/SessionStore.ts'
import { IUserStore } from '@/store/pinia/UserStore.ts'
import { provideObject as checkUserObject } from '@/composables/users/checkUser.ts'

const { isUser, isAdmin } = checkUserObject

export const otivoAdminGuard = async (
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext,
  userStore: IUserStore,
  sessionStore: ISessionStore,
): Promise<void> => {
  console.info(`[Guard] otivoAdminGuard: guard activated for route: ${to.name}`)
  const inactivityTimer = useInactivityTimer(sessionStore)
  if (!isAuthenticated.value) {
    next({ name: 'login' })
    return
  }

  userStore.fetchUser()
  inactivityTimer.start(120)

  if (isUser()) {
    sessionStore.logout()
  }

  if (isAdmin() && to.name && typeof to.name === 'string') {
    try {
      to.name.startsWith('admin.') ? next() : next({ name: `admin.${to.name}` })
      return
    } catch (error) {
      console.error(`Admin route 'admin.${to.name}' does not exist`, error)
      return
    }
  }
}

export const adminAuthGuard = async (
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext,
  userStore: IUserStore,
  sessionStore: ISessionStore,
): Promise<void> => {
  const inactivityTimer = useInactivityTimer(sessionStore)
  if (isAuthenticated.value) {
    if (localStorage.getItem('activeManagedUser')) {
      userStore.fetchUser()
    }
    inactivityTimer.start(120)
    switch (userRole.value) {
      case 'superadmin':
        next()
        return
      case 'callcentre':
        if (to.path !== '/admin-portal/home') next()
        else next('/admin-portal/search-users')
        return
      case 'backoffice':
        if (to.path !== '/admin-portal/home') next()
        else next('/admin-portal/reports')
        return
      default:
        console.error('error no cfs admin role')
        sessionStore.logout()
    }
  } else next('/admin')
}

export const clientAuthGuard = async (
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext,
): Promise<void> => {
  if (isAuthenticated.value) {
    next()
  } else {
    login()
  }
}
